package scroll

import common.dto.ElementType
import common.dto.Vec3d
import ext.asEuler
import ext.asVec3d
import three.js.Euler
import three.js.Quaternion
import kotlin.math.PI

val mainScrollAnimation: ScrollAnimation = listOf(
    // Brixi
    ScrollKeyframe(
        0.0, listOf(
            ScrollElement(ElementType.Brixi, id = "brixi1", rot = Vec3d(x = -PI / 2)),
        )
    ),
    // Alle Raumrichtungen
    ScrollKeyframe(
        0.8..1.2, listOf(
            ScrollElement(ElementType.Brixi, id = "brixi1"),
            ScrollElement(ElementType.Twister, pos = Vec3d(x = 16.0), rot = Vec3d(z = PI / 2), id = "twister1"),
            ScrollElement(ElementType.`1x2`, pos = Vec3d(x = -12.0), introOffset = Vec3d(x = -100.0)),
            ScrollElement(
                ElementType.`2x2`,
                pos = Vec3d(x = -20.0, y = 38.0),
                rot = Vec3d(x = PI / 2, y = PI / 8),
                introOffset = Vec3d(x = -100.0, y = 200.0),
                outroOffset = Vec3d(x = -100.0, y = 200.0),
            ),
        ), globalTransform = Vec3d(x = -10.0, y = -20.0, z = -80.0)
    ),
    // Nur Twister
    ScrollKeyframe(
        1.5, listOf(
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = -10.0), id = "brixi1"),
            ScrollElement(ElementType.Twister, pos = Vec3d(x = 6.0), rot = Vec3d(z = PI / 2), id = "twister1"),
        ), globalTransform = Vec3d(x = -10.0, z = -40.0)
    ),
    // Drehbare Elemente
    ScrollKeyframe(
        1.8, listOf(
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = -10.0), id = "brixi1"),
            ScrollElement(ElementType.Twister, pos = Vec3d(x = 6.0), rot = Vec3d(z = PI / 2), id = "twister1"),
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = 22.0), id = "brixi2"),
        ), globalTransform = Vec3d(x = -10.0, z = -40.0)
    ),
    // -> Brixi rotiert sich
    ScrollKeyframe(
        2.6, listOf(
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = -10.0), id = "brixi1"),
            ScrollElement(ElementType.Twister, pos = Vec3d(x = 6.0), rot = Vec3d(z = PI / 2), id = "twister1"),
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = 22.0), rot = Vec3d(x = -PI), id = "brixi2"),
        ), globalTransform = Vec3d(x = -10.0, z = -40.0)
    ),
    // Für kleine ...
    ScrollKeyframe(
        2.9..3.4, listOf(
            // body
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = -10.0), id = "brixi1"),
            ScrollElement(ElementType.Twister, pos = Vec3d(x = 6.0), rot = Vec3d(z = PI / 2), id = "twister1"),
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = 22.0), rot = Vec3d(x = -PI), id = "brixi2"),

            // legs
            ScrollElement(ElementType.`1x3`, pos = Vec3d(x = -10.0, y = -32.0, z = 12.0), rot = Vec3d(x = PI / 2), id = "leg1", introOffset = Vec3d(z = 500.0)),
            ScrollElement(ElementType.`1x3`, pos = Vec3d(x = 22.0, y = -32.0, z = 12.0), rot = Vec3d(x = PI / 2), id = "leg2", introOffset = Vec3d(z = 500.0)),
            ScrollElement(ElementType.`1x3`, pos = Vec3d(x = -10.0, y = -32.0, z = -20.0), rot = Vec3d(x = PI / 2), id = "leg3", introOffset = Vec3d(z = -500.0)),
            ScrollElement(ElementType.`1x3`, pos = Vec3d(x = 22.0, y = -32.0, z = -20.0), rot = Vec3d(x = PI / 2), id = "leg4", introOffset = Vec3d(z = -500.0)),

            // neck, head, nose
            ScrollElement(ElementType.`1x3`, pos = Vec3d(x = 34.0, y = 38.0), rot = Vec3d(x = PI / 2), id = "neck", outroOffset = Vec3d(y = 200.0)),
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = 46.0, y = 70.0), rot = Vec3d(x = PI / 2), id = "head"),
            ScrollElement(ElementType.Twister, pos = Vec3d(x = 62.0, y = 70.0), rot = Vec3d(z = PI / 2), id = "nose"),

            // tail
            ScrollElement(ElementType.`2x2`, pos = Vec3d(x = -35.0, y = -11.0), rot = Vec3d(x = PI / 2, y = -PI / 8), id = "tail", introOffset = Vec3d(x = -200.0, y = 200.0)),

            ), globalTransform = Vec3d(x = -10.0, y = -10.0, z = -280.0)
    ),
    // ...
    ScrollKeyframe(
        3.7, listOf(
            // lower body extends to 3 brixis
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = -62.0), id = "brixi1"),
            ScrollElement(ElementType.Twister, pos = Vec3d(x = -46.0), rot = Vec3d(z = PI / 2), id = "twister1"),
            // -> middle lower body comes in from behind
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = -20.0), id = "brixi1.5", introOffset = Vec3d(z = -2000.0)), // comes in from behind
            ScrollElement(ElementType.Twister, pos = Vec3d(x = -4.0), rot = Vec3d(z = PI / 2), id = "twister2", introOffset = Vec3d(z = -2000.0)), // comes in from behind

            ScrollElement(ElementType.Brixi, pos = Vec3d(x = 22.0), rot = Vec3d(x = -PI), id = "brixi2"),

            // upper body comes from above
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = -42.0, y = 52.0), id = "upper-brixi1", introOffset = Vec3d(y = 200.0)),
            ScrollElement(ElementType.Twister, pos = Vec3d(x = -26.0, y = 52.0), rot = Vec3d(z = PI / 2), id = "upper-twister1", introOffset = Vec3d(y = 200.0)),
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = -10.0, y = 52.0), id = "upper-brixi1.5", introOffset = Vec3d(y = 200.0)),
            ScrollElement(ElementType.Twister, pos = Vec3d(x = 6.0, y = 52.0), rot = Vec3d(z = PI / 2), id = "upper-twister2", introOffset = Vec3d(y = 200.0)),
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = 22.0, y = 52.0), rot = Vec3d(x = -PI), id = "upper-brixi2", introOffset = Vec3d(y = 200.0)),
            // -> 3 twisters for connection
            ScrollElement(ElementType.Twister, pos = Vec3d(x = -42.0, y = 36.0), id = "connector-twister1", introOffset = Vec3d(y = 200.0)),
            ScrollElement(ElementType.Twister, pos = Vec3d(x = -10.0, y = 36.0), id = "connector-twister2", introOffset = Vec3d(y = 200.0)),
            ScrollElement(ElementType.Twister, pos = Vec3d(x = 22.0, y = 36.0), id = "connector-twister3", introOffset = Vec3d(y = 200.0)),

            // back legs move to the left with left body
            ScrollElement(ElementType.`1x3`, pos = Vec3d(x = -62.0, y = -32.0, z = 12.0), rot = Vec3d(x = PI / 2), id = "leg1", introOffset = Vec3d(z = 500.0)),
            ScrollElement(ElementType.`1x3`, pos = Vec3d(x = -62.0, y = -32.0, z = -20.0), rot = Vec3d(x = PI / 2), id = "leg3", introOffset = Vec3d(z = -500.0)),

            // front legs stay in place
            ScrollElement(ElementType.`1x3`, pos = Vec3d(x = 22.0, y = -32.0, z = 12.0), rot = Vec3d(x = PI / 2), id = "leg2", introOffset = Vec3d(z = 500.0)),
            ScrollElement(ElementType.`1x3`, pos = Vec3d(x = 22.0, y = -32.0, z = -20.0), rot = Vec3d(x = PI / 2), id = "leg4", introOffset = Vec3d(z = -500.0)),

            // head and nose move to the right, neck gets replaced by long-neck
            ScrollElement(ElementType.`1x4`, pos = Vec3d(x = 54.0, y = 72.0), rot = Vec3d(x = PI / 2), id = "long-neck", introOffset = Vec3d(y = -200.0)),
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = 86.0, y = 98.0), rot = Vec3d(x = PI / 2), id = "head"),
            ScrollElement(ElementType.Twister, pos = Vec3d(x = 102.0, y = 98.0), rot = Vec3d(z = PI / 2), id = "nose"),

            // tail
            ScrollElement(ElementType.`2x2`, pos = Vec3d(x = -108.0, y = 60.0), rot = Vec3d(x = PI / 2, y = -PI / 4), id = "tail", introOffset = Vec3d(x = -200.0, y = 200.0)),
        ), globalTransform = Vec3d(x = -10.0, y = -20.0, z = -300.0)
    ),

    // ...
    ScrollKeyframe(
        4.1, listOf(
            // lower body extends to 3 brixis
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = -42.0), id = "brixi1"),
            ScrollElement(ElementType.Twister, pos = Vec3d(x = -26.0), rot = Vec3d(z = PI / 2), id = "twister1"),
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = -10.0), id = "brixi1.5", introOffset = Vec3d(z = -2000.0)), // comes in from behind
            ScrollElement(ElementType.Twister, pos = Vec3d(x = 6.0), rot = Vec3d(z = PI / 2), id = "twister2", introOffset = Vec3d(z = -2000.0)), // comes in from behind
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = 22.0), rot = Vec3d(x = -PI), id = "brixi2"),

            // upper body comes from above
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = -42.0, y = 32.0), id = "upper-brixi1", introOffset = Vec3d(y = 200.0)),
            ScrollElement(ElementType.Twister, pos = Vec3d(x = -26.0, y = 32.0), rot = Vec3d(z = PI / 2), id = "upper-twister1", introOffset = Vec3d(y = 200.0)),
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = -10.0, y = 32.0), id = "upper-brixi1.5", introOffset = Vec3d(y = 200.0)),
            ScrollElement(ElementType.Twister, pos = Vec3d(x = 6.0, y = 32.0), rot = Vec3d(z = PI / 2), id = "upper-twister2", introOffset = Vec3d(y = 200.0)),
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = 22.0, y = 32.0), rot = Vec3d(x = -PI), id = "upper-brixi2", introOffset = Vec3d(y = 200.0)),
            // -> 3 twisters for connection
            ScrollElement(ElementType.Twister, pos = Vec3d(x = -42.0, y = 16.0), id = "connector-twister1", introOffset = Vec3d(y = 200.0)),
            ScrollElement(ElementType.Twister, pos = Vec3d(x = -10.0, y = 16.0), id = "connector-twister2", introOffset = Vec3d(y = 200.0)),
            ScrollElement(ElementType.Twister, pos = Vec3d(x = 22.0, y = 16.0), id = "connector-twister3", introOffset = Vec3d(y = 200.0)),

            // back legs move to the left with left body
            ScrollElement(ElementType.`1x3`, pos = Vec3d(x = -42.0, y = -32.0, z = 12.0), rot = Vec3d(x = PI / 2), id = "leg1", introOffset = Vec3d(z = 500.0)),
            ScrollElement(ElementType.`1x3`, pos = Vec3d(x = -42.0, y = -32.0, z = -20.0), rot = Vec3d(x = PI / 2), id = "leg3", introOffset = Vec3d(z = -500.0)),

            // front legs stay in place
            ScrollElement(ElementType.`1x3`, pos = Vec3d(x = 22.0, y = -32.0, z = 12.0), rot = Vec3d(x = PI / 2), id = "leg2", introOffset = Vec3d(z = 500.0)),
            ScrollElement(ElementType.`1x3`, pos = Vec3d(x = 22.0, y = -32.0, z = -20.0), rot = Vec3d(x = PI / 2), id = "leg4", introOffset = Vec3d(z = -500.0)),

            // neck, head and nose move to the right
            ScrollElement(ElementType.`1x4`, pos = Vec3d(x = 54.0, y = 72.0), rot = Vec3d(x = PI / 2), id = "long-neck", introOffset = Vec3d(y = -200.0)),
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = 66.0, y = 122.0), rot = Vec3d(x = PI / 2), id = "head"),
            ScrollElement(ElementType.Twister, pos = Vec3d(x = 82.0, y = 122.0), rot = Vec3d(z = PI / 2), id = "nose"),

            // tail
            ScrollElement(ElementType.`2x2`, pos = Vec3d(x = -108.0, y = 60.0), rot = Vec3d(x = PI / 2, y = -PI / 4), id = "tail", introOffset = Vec3d(x = -200.0, y = 200.0)),
        ), globalTransform = Vec3d(x = -10.0, y = -20.0, z = -350.0)
    ),

    // ... und große Baumeister!
    ScrollKeyframe(
        4.5..5.0, listOf(
            // lower body extends to 3 brixis
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = -42.0), id = "brixi1"),
            ScrollElement(ElementType.Twister, pos = Vec3d(x = -26.0), rot = Vec3d(z = PI / 2), id = "twister1"),
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = -10.0), id = "brixi1.5", introOffset = Vec3d(z = -2000.0)), // comes in from behind
            ScrollElement(ElementType.Twister, pos = Vec3d(x = 6.0), rot = Vec3d(z = PI / 2), id = "twister2", introOffset = Vec3d(z = -2000.0)), // comes in from behind
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = 22.0), rot = Vec3d(x = -PI), id = "brixi2"),

            // upper body comes from above
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = -42.0, y = 32.0), id = "upper-brixi1", introOffset = Vec3d(y = 200.0)),
            ScrollElement(ElementType.Twister, pos = Vec3d(x = -26.0, y = 32.0), rot = Vec3d(z = PI / 2), id = "upper-twister1", introOffset = Vec3d(y = 200.0)),
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = -10.0, y = 32.0), id = "upper-brixi1.5", introOffset = Vec3d(y = 200.0)),
            ScrollElement(ElementType.Twister, pos = Vec3d(x = 6.0, y = 32.0), rot = Vec3d(z = PI / 2), id = "upper-twister2", introOffset = Vec3d(y = 200.0)),
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = 22.0, y = 32.0), rot = Vec3d(x = -PI), id = "upper-brixi2", introOffset = Vec3d(y = 200.0)),
            // -> 3 twisters for connection
            ScrollElement(ElementType.Twister, pos = Vec3d(x = -42.0, y = 16.0), id = "connector-twister1", introOffset = Vec3d(y = 200.0)),
            ScrollElement(ElementType.Twister, pos = Vec3d(x = -10.0, y = 16.0), id = "connector-twister2", introOffset = Vec3d(y = 200.0)),
            ScrollElement(ElementType.Twister, pos = Vec3d(x = 22.0, y = 16.0), id = "connector-twister3", introOffset = Vec3d(y = 200.0)),

            // back legs move to the left with left body
            ScrollElement(ElementType.`1x3`, pos = Vec3d(x = -42.0, y = -32.0, z = 12.0), rot = Vec3d(x = PI / 2), id = "leg1", introOffset = Vec3d(z = 500.0)),
            ScrollElement(ElementType.`1x3`, pos = Vec3d(x = -42.0, y = -32.0, z = -20.0), rot = Vec3d(x = PI / 2), id = "leg3", introOffset = Vec3d(z = -500.0)),

            // front legs stay in place
            ScrollElement(ElementType.`1x3`, pos = Vec3d(x = 22.0, y = -32.0, z = 12.0), rot = Vec3d(x = PI / 2), id = "leg2", introOffset = Vec3d(z = 500.0)),
            ScrollElement(ElementType.`1x3`, pos = Vec3d(x = 22.0, y = -32.0, z = -20.0), rot = Vec3d(x = PI / 2), id = "leg4", introOffset = Vec3d(z = -500.0)),

            // neck, head and nose move to the right
            ScrollElement(ElementType.`1x4`, pos = Vec3d(x = 34.0, y = 72.0), rot = Vec3d(x = PI / 2), id = "long-neck", introOffset = Vec3d(y = -200.0)),
            ScrollElement(ElementType.Brixi, pos = Vec3d(x = 46.0, y = 122.0), rot = Vec3d(x = PI / 2), id = "head"),
            ScrollElement(ElementType.Twister, pos = Vec3d(x = 62.0, y = 122.0), rot = Vec3d(z = PI / 2), id = "nose"),

            // tail
            ScrollElement(ElementType.`2x2`, pos = Vec3d(x = -66.0, y = 20.0), rot = Vec3d(x = PI / 2, y = -PI / 8), id = "tail", introOffset = Vec3d(x = -200.0, y = 200.0)),
        ), globalTransform = Vec3d(x = -10.0, y = -30.0, z = -400.0)
    ),
// hacky fix for rotations; see below
).map { it.copy(elements = it.elements.map { elt -> elt.copy(rot = elt.rot.fix()) }) }

/**
 * Hacky fix for the animation above. Only needed because this animation was created before the
 * models where created with a different orientation. In the future, rotation should be specified
 * so that it matches the model orientation.
 */
private fun Vec3d.fix(): Vec3d {
    val quaternion = Quaternion().setFromEuler(asEuler())
    val appliedFix = Quaternion().setFromEuler(Euler(x = PI / 2))
    val fixedQuaternion = quaternion.multiply(appliedFix)
    val fixedEuler = Euler().setFromQuaternion(fixedQuaternion)
    return fixedEuler.asVec3d()
}